import React from "react";
import VendorMaterialsWorkspace from "../../components/VendorMaterialsWorkspace";
import PageHeader from "../../components/PageHeader";
import { useTerminology } from "../../context/TerminologyContext";

export default function AdminVendorMaterialsPage() {
  const { t, tp } = useTerminology();
  return (
    <div className="page-stack">
      <PageHeader
        eyebrow="Admin"
        icon="vendors"
        title={`${t("vendor")} & ${tp("material")}`}
        subtitle={`Manage ${t("vendor").toLowerCase()} onboarding, ${tp("material").toLowerCase()}, and threshold configuration with search.`}
      />
      <VendorMaterialsWorkspace scopeLabel="Admin" />
    </div>
  );
}
